export class ApiError<T> extends Error {
  options?: T
  status?: number

  constructor(message: string, options?: T, status?: number) {
    super(message)
    this.options = options
    this.status = status
  }
}
